import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLayoutHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 9.5C2.25 7.98122 3.48122 6.75 5 6.75C6.51878 6.75 7.75 7.98122 7.75 9.5V14.5C7.75 16.0188 6.51878 17.25 5 17.25C3.48122 17.25 2.25 16.0188 2.25 14.5V9.5ZM5 15.75C5.69036 15.75 6.25 15.1904 6.25 14.5V9.5C6.25 8.80964 5.69036 8.25 5 8.25C4.30964 8.25 3.75 8.80964 3.75 9.5V14.5C3.75 15.1904 4.30964 15.75 5 15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.25 9.5C9.25 7.98122 10.4812 6.75 12 6.75C13.5188 6.75 14.75 7.98122 14.75 9.5V14.5C14.75 16.0188 13.5188 17.25 12 17.25C10.4812 17.25 9.25 16.0188 9.25 14.5V9.5ZM12 15.75C12.6904 15.75 13.25 15.1904 13.25 14.5V9.5C13.25 8.80964 12.6904 8.25 12 8.25C11.3096 8.25 10.75 8.80964 10.75 9.5V14.5C10.75 15.1904 11.3096 15.75 12 15.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 6.75C20.5188 6.75 21.75 7.98122 21.75 9.5V14.5C21.75 16.0188 20.5188 17.25 19 17.25C17.4812 17.25 16.25 16.0188 16.25 14.5V9.5C16.25 7.98122 17.4812 6.75 19 6.75ZM17.75 14.5C17.75 15.1904 18.3096 15.75 19 15.75C19.6904 15.75 20.25 15.1904 20.25 14.5V9.5C20.25 8.80964 19.6904 8.25 19 8.25C18.3096 8.25 17.75 8.80964 17.75 9.5V14.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLayoutHorizontal as ReactComponent };
